module.exports = __webpack_public_path__ + "img/premiseIcon2.77b7f718.png";